var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacklink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m18.387 19.79-.094-.083L14 15.415V18a1 1 0 0 1-2 0l.003-5.075.017-.126.03-.111.044-.111.052-.098.067-.096.08-.09a1.01 1.01 0 0 1 .112-.097l.11-.071.114-.054.105-.035.15-.03L13 12h5a1 1 0 1 1 0 2h-2.585l4.292 4.293a1 1 0 0 1-1.32 1.497ZM7.036 9.136l-4.45 4.45-.117.127a2 2 0 0 0 2.818 2.818l.127-.117 4.45-4.449a4 4 0 0 1-.885 3.704l-.15.16-2 2A4 4 0 0 1 1.02 12.33l.15-.16 2-2a3.998 3.998 0 0 1 3.865-1.035Zm6.671-3.843a1 1 0 0 1 .083 1.32l-.083.094-7 7a1 1 0 0 1-1.497-1.32l.083-.094 7-7a1 1 0 0 1 1.414 0Zm4.121-4.121a4 4 0 0 1 .151 5.497l-.15.16-2 2a3.998 3.998 0 0 1-3.864 1.036l4.45-4.45.116-.128a2 2 0 0 0-2.818-2.818l-.127.117-4.45 4.45a4 4 0 0 1 .885-3.705l.15-.16 2-2a4 4 0 0 1 5.657 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklink);
export default __webpack_public_path__ + "static/media/backlink.5f3757b4f424eb1e235619f6cfb87224.svg";
export { ForwardRef as ReactComponent };